/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import Select, { StylesConfig } from 'react-select';
import { SelectOption } from '../../../types/select';
import { ViewMap, ViewValues } from '../../survey-overview-sidebar/viewOptions';
import { CustomMetricContext } from '../CustomMetricContainer';
import { QUESTION } from '../../../constants/terminology';

const getViewOptions = () => {
  return [ViewValues.Custom, ViewValues.AssignedMetrics].map((k: ViewValues) => ViewMap[k]);
};

const reactSelectStyles: StylesConfig<{ value: string; label: string }, false> = {
  container: (provided) => ({
    ...provided,
    minWidth: '270px',
  }),
  control: (provided) => ({
    ...provided,
    minHeight: 'unset',
  }),
  singleValue: (provided) => ({ ...provided, color: 'var(--theme-TextMedium)' }),
  valueContainer: (provided) => ({ ...provided, position: 'unset' }),
  indicatorsContainer: (provided) => ({ ...provided, maxHeight: '26px' }),
  indicatorSeparator: (provided) => ({ ...provided, display: 'none' }),
  menu: (provider) => ({ ...provider, marginTop: '1px' }),
};

export const ViewQuestionsDropdown = () => {
  const { groupBy, setGroupBy } = React.useContext(CustomMetricContext);

  const onChange = (selectedOption: SelectOption<string | null> | null) =>
    setGroupBy(selectedOption?.value as ViewValues);
  const options = getViewOptions();
  const value = options.find((o) => o.value === groupBy);

  return (
    <Select
      styles={reactSelectStyles}
      placeholder={`Select View ${QUESTION.CAPITALIZED_PLURAL} By`}
      options={options}
      value={value}
      onChange={onChange}
      isSearchable={false}
    />
  );
};
